import { render, staticRenderFns } from "./CapabilityWheel.vue?vue&type=template&id=acfdf0bc&scoped=true&"
import script from "./CapabilityWheel.vue?vue&type=script&lang=ts&"
export * from "./CapabilityWheel.vue?vue&type=script&lang=ts&"
import style0 from "./CapabilityWheel.vue?vue&type=style&index=0&id=acfdf0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfdf0bc",
  null
  
)

export default component.exports